import * as React from 'react';
import CheckBox from 'src/components/shared/CheckBox';
import { ExperianQuestion, Answer } from 'src/models/question';

interface Props {
    questions: Array<ExperianQuestion>;
    answersIndex: Array<number>;
    handleChange: (value: string, field: string) => void;
}

class QuestionSet extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);
    }

    convertAnswerToString = (questionIndex: number, question: string, answerIndex: number, answer: string): string => {
        let selectedAnswer: Answer = {
            questionIndex: questionIndex,
            question: question,
            answerIndex: answerIndex,
            answer: answer
        };
        return JSON.stringify(selectedAnswer);
    }

    render(): JSX.Element {
        const { questions, answersIndex } = this.props;

        return (
            <table className="table table-borderless experian-tbl">
                <tbody>
                    {
                        questions && questions.length > 0 &&
                        questions.map((q, indexQuestion) => (
                            q.questionSelect && q.questionSelect.length > 0 &&
                            <React.Fragment key={indexQuestion}>
                                {
                                    q.questionSelect.map((qSelectAnswer, indexAnswer) => (
                                        <tr key={indexQuestion + indexAnswer}>
                                            <td className="width350">{indexAnswer === 0 ? <label className="col-form-label">{`${indexQuestion + 1} . ${q.questionText}`}</label> : null}</td>
                                            <td>
                                                <CheckBox
                                                    id={`cbAnswerSelect_${indexQuestion.toString()}_${indexAnswer.toString()}`}
                                                    checked={answersIndex[indexQuestion] === indexAnswer}
                                                    value={this.convertAnswerToString(indexQuestion, q.questionText, indexAnswer, qSelectAnswer)}
                                                    onChange={this.props.handleChange}
                                                    field={`answer_${indexQuestion.toString()}_${indexAnswer.toString()}`}
                                                    isCheckbox={true}
                                                    label={qSelectAnswer}
                                                    extendClass="custom-control-inline"
                                                />
                                            </td>
                                        </tr>
                                    ))
                                }
                                <tr><td /></tr>
                            </React.Fragment>
                        ))
                    }
                </tbody>
            </table>
        );
    }
}

export default QuestionSet;


// WEBPACK FOOTER //
// ./src/components/Experian/QuestionSet.tsx